import { render, staticRenderFns } from "./FeedAlert.vue?vue&type=template&id=58d94ec6&scoped=true"
import script from "./FeedAlert.vue?vue&type=script&lang=js"
export * from "./FeedAlert.vue?vue&type=script&lang=js"
import style0 from "./FeedAlert.vue?vue&type=style&index=0&id=58d94ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d94ec6",
  null
  
)

export default component.exports